import script from "./SwapInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwapInfo.vue?vue&type=script&setup=true&lang=ts"

import "./SwapInfo.vue?vue&type=style&index=0&id=360e127d&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360e127d"]])

export default __exports__